import { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import CloseIcon from '@mui/icons-material/Close';
import planFilterButton from "../../../asset/image/planFilterButton.svg";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, ListItem, ListItemText, DialogActions, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, Switch } from "@mui/material";

import CustomLoader from "../../Loader/CustomLoader";
import _ from "lodash";
import { getDataFromLocalStorageParsed, getDecodeURI } from "../../../utils/util";
import OrgSelection from "../../OrgSelection";
import { getServiceLinesForSubcription, subscribeToServiceLines, getServiceLines, ACTION_TYPES } from "../slice";
import { fetchServiceLinesForSubscription } from "../../../actions/Users/authenticate";
import { Pagination } from "../../StarlinkPagination";
import moment from "moment-timezone";



function SubscribeToAllServiceLines(props) {

    const { authReducer, errorReducer, history, location, dpIds, serviceLinesForSubscription, getServiceLines, subscribedSLs, unsubscribedSLs, subscribeToServiceLines, subscribeServiceLines, getServiceLinesForSubcription, allServiceLines, fetchServiceLinesForSubscription, totalServiceLines, open, setOpen, selectedServiceAccount, newSummaryServiceLine, gettingServiceLines } = props;
    const dispatch = useDispatch();
    const queryParams = new Map<string, string>(Object.entries(getDecodeURI(location.search)));
    const loggedInUser = getDataFromLocalStorageParsed("loggedInUser");
    const params = getDecodeURI(location.search)
    const [selectedOu, setSelectedOu] = useState(params?.ouId)
    const [searchText, setSearchText] = useState<string>(queryParams.get('search') || '');
    const [selectedDp, setSelectedDp] = useState<any>(null);
    const [highlightedRows, setHighlightedRows] = useState<any>([]);
    const searchTimeoutRef = useRef<number | undefined>();
    const [subscribedServiceLines, setsubscribedServiceLines] = useState([]);
    const [unsubscribedServiceLines, setUnsubscribedServiceLines] = useState([]);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
    const [switchServiceLineToggle, setSwitchServiceLineToggle] = useState(false)


    const [tableParams, setTableParams] = useState<{
        page: number;
        size: number;
        sortBy: any;
        sortOrder: any;
        search: string;
        serviceLineStatus: any;
    }>({
        page: 1,
        size: 10000,
        sortBy: 'serviceLineName',
        sortOrder: queryParams.has('sortOrder') ? queryParams.get('sortOrder') as any : 'asc',
        search: queryParams.has('search') ? queryParams.get('search') as string : '',
        serviceLineStatus: queryParams.has('serviceLineStatus') ? queryParams.get('serviceLineStatus')?.split(',') as string[] : ['true', 'false']
    });

    const handleChangeDp = (ou: any) => {
        setSelectedDp(ou)
    }

    useEffect(() => {
        setSelectedDp({ id: authReducer?.selectedOu?.id, name: authReducer?.selectedOu?.name })
    }, [])


    useEffect(() => {
        handleChangeServiceLine()
    }, [tableParams, newSummaryServiceLine]);


    useEffect(() => {
        if (selectedDp && selectedDp?.id) {
            fetchServiceLinesForSubscription(selectedDp?.id, selectedServiceAccount)
        }
    }, [selectedDp])

    useEffect(() => {
        if (authReducer.fetchServiceLinesForSubscription) {
            handleChangeServiceLine()
        }
    }, [authReducer.fetchServiceLinesForSubscription])

    useEffect(() => {
        const active = serviceLinesForSubscription.filter(sl => sl.servicelineSubscription === true);
        const inactive = serviceLinesForSubscription.filter(sl => sl.servicelineSubscription === false || sl.servicelineSubscription === null);
        setsubscribedServiceLines(active);
        setUnsubscribedServiceLines(inactive);

    }, [serviceLinesForSubscription]);

    const handleChangeSwitch = (action) => {
        const date = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

        const requestData: { serviceLineNumber: any; dpId: string; user: any; action: string; startDate?: string | undefined; endDate?: string | undefined; } =
        {
            serviceLineNumber: highlightedRows?.map(sl => sl.serviceLineNumber),
            dpId: selectedDp?.id,
            user: loggedInUser?.data?.user?.userName,
            action: action
        };

        if (action === 'subscribe') {
            requestData.startDate = date;
        } else {
            requestData.endDate = date;
        }
        subscribeToServiceLines(requestData);
        
    }

    useEffect(()=>{

        if(!_.isEmpty(subscribeServiceLines)){
        setOpenConfirmDialog(false)
        setOpen(false)
        setHighlightedRows([])
        
        getServiceLines({
            accounts: selectedServiceAccount,
            dpIds,
            searchText: tableParams.search,
            sortBy: tableParams.sortBy,
            sortOrder: tableParams.sortOrder,
            page: tableParams.page,
            limit: tableParams.size,
            serviceLineStatus: tableParams.serviceLineStatus,
            serviceLines: Array.isArray(authReducer.fetchServiceLinesForSubscription.serviceLines) ? authReducer.fetchServiceLinesForSubscription.serviceLines?.filter(sl => sl !== '').map(sl => sl.id) : [],
        });
          dispatch({ type: ACTION_TYPES.SUBSCRIBE_SERVICE_LINES, payload: null });
        }

    },[subscribeServiceLines])


    const handleChangeServiceLine = () => {
        getServiceLinesForSubcription({
            accounts: selectedServiceAccount,
            dpIds,
            searchText: tableParams.search,
            sortBy: tableParams.sortBy,
            sortOrder: tableParams.sortOrder,
            page: tableParams.page,
            limit: tableParams.size,
            serviceLineStatus: tableParams.serviceLineStatus,
            serviceLines: Array.isArray(newSummaryServiceLine) ? newSummaryServiceLine?.filter(sl => sl !== '') : [],
        });
    }

    const handleChangePage = (event: any, newPage: number) => {
        setTableParams({ ...tableParams, page: newPage });
    };

    const handleChangeSize = (event: any) => {
        setTableParams({ ...tableParams, size: event.target.value, page: 1 });
    };

    const handleSearch = (value: string) => {
        setTableParams({
            ...tableParams,
            search: value,
            page: 1
        });
    }

    const handleOnSearchClick = () => {
        handleSearch(searchText);
    }

    const handleOnSearchClear = () => {
        setSearchText('');
        handleSearch('');
    }

    const handleHighlightedRowClick = (row) => {
        setHighlightedRows((prevHighlighted) => {
            const exists = prevHighlighted.some((item) => item?.serviceLineNumber === row?.serviceLineNumber);
            return exists
                ? prevHighlighted.filter((item) => item?.serviceLineNumber !== row?.serviceLineNumber)
                : [...prevHighlighted, row];
        });
    };


    const isHighlighted = (serviceLineNumber: string) => {
        return highlightedRows.some((item) => item.serviceLineNumber === serviceLineNumber);
    };

    const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchText(e.target.value);
    
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
    
        searchTimeoutRef.current = window.setTimeout(() => {
            searchTimeoutRef.current = undefined;
            handleSearch(e.target.value);
        }, 1000);
    };

    return (
        <>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth className="menuScroll plan-usage-hierarchy-popup-sl">
                <DialogTitle className='delete-content-filter-title'>
                    Subscribe Service Lines
                    <IconButton onClick={() => setOpen(false)} sx={{ position: "absolute", right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className="dialog-list-content-filter-dialog-content">
                    <Grid className="middleTable" >
                        {/* <Grid container className="strPlans-senderGridTop">
                            <Grid item className="strPlans-PlanIcon-grid">
                                <div className="strPlans-PlanIconMiddle" ></div>
                                <Typography className="strPlans-senderTypo">{selectedPlan?.name}</Typography>
                            </Grid>
                        </Grid> */}
                        <div className={`strPlans-pb10hierarchy-subscription strPlan-tableHierarchy-Height2 strPlans-pb10 electedMiddle`}>
                            <>
                                <Grid container spacing={1} className="configTable">
                                    <Grid item xs={6} className="configuration-form-build">
                                        {/* <img className="icon-cursor strPlans-pd-r-10" src={planFilterButton} /> */}
                                        <OrgSelection label={"Organization"} value={selectedDp} onChange={handleChangeDp} />

                                    </Grid>
                                    <Grid item xs={6} className="usage-search-border-color">
                                        <Box className="strPlans-searchbarBox">
                                            <TextField
                                                id="search"
                                                variant="outlined"
                                                placeholder="Type something"
                                                autoComplete="off"
                                                classes={{ root: "input-box-serviceline" }}
                                                size="small"
                                                value={searchText}
                                                onChange={handleOnSearchChange}
                                                onKeyDown={(e) => { if (e.key === 'Enter') { handleOnSearchClick() } }}
                                                InputLabelProps={{ className: "serachLabel" }}
                                                InputProps={{
                                                    className: "serachBar",
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            {!searchText && <SearchIcon
                                                                className="cursorPointer input-search-icons" onClick={handleOnSearchClick}
                                                            />}
                                                            {searchText && <CloseIcon
                                                                className="cursorPointer input-search-icons"
                                                                onClick={handleOnSearchClear}
                                                            />}
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                                <div className="service-lines-container">
                                    <div className="service-lines-card">
                                        <div className="label">Unsubscribed</div>
                                        <div className={"highlight"}>{unsubscribedSLs || 0}</div>
                                    </div>
                                    <div className="service-lines-card">
                                        <div className="label">Subscribed</div>
                                        <div className={"highlight"}>{subscribedSLs || 0}</div>
                                    </div>
                                </div>
                                {/* <Pagination count={unsubscribedSLs} onPageChange={handleChangePage} page={tableParams.page} rowsPerPage={tableParams.size} onRowsPerPageChange={handleChangeSize} /> */}

                                <TableContainer component={Paper} className="starlink--table_container strMap-table strPlan-tableHeight-subscription" >
                                    <Table stickyHeader size="small" aria-label="plan-hierarchy-table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                               
                                                    <span className="font-wt-900">{switchServiceLineToggle ? "Service Line" : "Service Line" }</span>
                                                    <Tooltip title="SL Name / SL Number">
                                                    <Switch size="small"
                                                        checked={switchServiceLineToggle}
                                                        onChange={(e) => {  setSwitchServiceLineToggle(!switchServiceLineToggle) }}
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                    />
                                                </Tooltip>
                                                    </TableCell> 
                                                <TableCell><span className="font-wt-900">Organization</span></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className="strPlan-sl-table">
                                            {unsubscribedServiceLines?.length > 0 ? (
                                                unsubscribedServiceLines?.map((row: any) => (
                                                    <TableRow key={row.serviceLineNumber}
                                                        onClick={() => {
                                                            handleHighlightedRowClick(row)
                                                        }}>
                                                        <TableCell className={`strPlans-table-cell subscribe-sl-max-width ${isHighlighted(row.serviceLineNumber) ? 'highlighted' : ''}`} >{switchServiceLineToggle ? row?.serviceLineNumber : row?.serviceLineName}</TableCell>
                                                        <TableCell className={`strPlans-table-cell ${isHighlighted(row.serviceLineNumber) ? 'highlighted' : ''}`}>{row?.dpName}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={4} align="center">
                                                        No service lines available.
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Grid container spacing={2} className="strPlans-senderGrid">

                                    <Grid item >
                                        <Button style={{ marginRight: "10px" }} sx={{ textTransform: 'none' }} variant="outlined" className='strPlans-cancel' disabled={unsubscribedServiceLines?.length == 0}
                                            onClick={() => { setHighlightedRows([]) }} >  Clear</Button>
                                        <Button sx={{ textTransform: 'none' }} variant="outlined" className='strPlans-selectAll' disabled={unsubscribedServiceLines?.length == 0}
                                            onClick={() => { setHighlightedRows([...unsubscribedServiceLines]) }} >  Select All </Button>
                                    </Grid>
                                    <Grid item >
                                        <Button disabled={highlightedRows?.length === 0} size="small" variant="contained" className='starlink--button_contained--primary' onClick={() => { setOpenConfirmDialog(true) }} >Verify</Button>
                                    </Grid>

                                </Grid>
                            </>
                        </div>
                    </Grid>
                </DialogContent>

            </Dialog>

            <Dialog
                open={openConfirmDialog}
                onClose={() => { setOpenConfirmDialog(false); }}
                maxWidth="md"
                // fullWidth
                PaperProps={{
                    style: {
                        overflow: 'hidden'
                    }
                }}
            >
                <DialogTitle className="strPlans-title">Subscribe Service Lines</DialogTitle>
                <DialogContent>
                    <Typography className="strPlans-text">
                        Following Service Lines will be subscribed:
                    </Typography>

                    {highlightedRows?.map((highlight, index) => (
                        <ListItem key={highlight?.serviceLineNumber} className="strPlans-listItem">
                            <div className="strPlans-number">{index + 1}</div>
                            <ListItemText
                                primary={highlight?.serviceLineName}
                                secondary={`Service Line: ${highlight?.serviceLineNumber}`}
                                className="strPlans-listText"
                            />
                        </ListItem>
                    ))}
                </DialogContent>
                <DialogActions className="strPlans-dialogActions">
                    <Button onClick={() => setOpenConfirmDialog(false)} variant="outlined" className='starlink--button--cancel'>Go Back</Button>
                    <Button
                        onClick={() => { handleChangeSwitch("subscribe") }}
                        variant="contained" className='starlink--button_contained--primary'
                    >
                        Subscribe
                    </Button>
                </DialogActions>
            </Dialog>

            { gettingServiceLines ? (
                <CustomLoader
                    showLoader={true}
                    loadingText={"Please wait..."}
                />
            ) : null}
        </>
    );
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    dpIds: state.starlinkCloud.dpIds,
    serviceLinesForSubscription: state.starlinkAdmin.serviceLinesForSubscription,
    totalServiceLines: state.starlinkAdmin.totalServiceLinesForSubscription,
    unsubscribedSLs: state.starlinkAdmin.unsubscribedSLs,
    subscribedSLs: state.starlinkAdmin.subscribedSLs,
    allServiceLines: state.starlinkReports.allServiceLines,
    availableProductsForAccount: state.starlinkAdmin.availableProductsForAccount,
    newSummaryServiceLine: state?.authReducer?.newSummaryServiceLine,
    subscriptionsForAccount: state.starlinkAdmin.subscriptionsForAccount,
    selectedServiceAccount: state?.authReducer?.selectedServiceAccount,
    subscribeServiceLines :  state.starlinkAdmin.subscribeServiceLines,
    gettingServiceLines: state.starlinkAdmin.gettingServiceLines,
});

export default withRouter(
    connect(mapStateToProps, {
        fetchServiceLinesForSubscription,
        getServiceLinesForSubcription,
        subscribeToServiceLines,
        getServiceLines

    })(SubscribeToAllServiceLines)
);